import Manifesto from "@/components/waylio/Manifesto";

export default function AboutPage() {
  return (
    <main className="pt-10 md:pt-12">
      <Manifesto />
    </main>
  );
}
